export default __webpack_public_path__ + "static/media/service2.0960f7d3.png";